export default __webpack_public_path__ + "static/media/FKGroteskNeue-Bold.c834c460.otf";